import React from 'react';
import PropTypes from 'prop-types';

function Button({ onClick }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick();
    }
  };

  return (
    <div
      id="add_new_button"
      onClick={() => onClick()}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex="0"
      className="d-flex align-items-center mb-2"
    >
      <div className="d-inline-block me-2">
        <i className="fa-solid fa-circle-plus fa-lg" />
      </div>
      <span className="fs-6">Add new</span>
    </div>
  );
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
};

function Header({ onCancel }) {
  return (
    <div className="d-inline-flex flex-column pt-1 mb-2">
      <div className="fs-4">Add New</div>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onCancel();
        }}
        className="btn btn-link btn-sm align-self-start px-0"
        style={{ cursor: 'pointer' }}
      >
        <i className="fa-solid fa-arrow-left" />
        &nbsp;Back
      </button>
    </div>
  );
}

Header.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

// Main Component
function AddNewButton({ onClick, active, onCancel }) {
  if (active) {
    return <Header onCancel={onCancel} />;
  }

  return <Button onClick={onClick} />;
}

AddNewButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default AddNewButton;
